import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { styled } from "@mui/material/styles";

import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  Menu,
  Toolbar,
  IconButton,
  Box,
  ListItemButton,
} from "@mui/material";

import MuiAppBar from "@mui/material/AppBar";

import MenuIcon from "@mui/icons-material/Menu";
import MoreIcon from "@mui/icons-material/MoreVert";
import LockIcon from "@mui/icons-material/Lock";

import { useSnackbar } from "notistack";

import Logo from "@assets/images/logo-white.png";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function AppHeader({ setSearchedValue, ...props }) {
  let history = useHistory();

  const location = useLocation();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  let fullName = localStorage.getItem("full_name");

  const onMenuItemClick = (path) => {
    // const { history } = props;
    setAnchorEl(null);
    // if (!Boolean(history)) return;
    // history.push(path);
    history.push(path);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const isAppBarVisible = (location) => {
    if (
      location.pathname === "/" ||
      location.pathname === "/login" ||
      location.pathname === "/logout" ||
      location.pathname === "/verify" ||
      location.pathname === "/forgot" ||
      location.pathname === "/resetpassword" ||
      location.pathname === "/mfa" ||
      location.pathname === "/observation-tablet-chart"
    ) {
      return false;
    } else {
      return true;
    }
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem
        data-test={"appbar-logout-btn"}
        onClick={() => onMenuItemClick("/logout")}
      >
        <ListItemIcon>
          <LockIcon />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={() => onMenuItemClick("/logout")}>
        <ListItemIcon>
          <LockIcon />
        </ListItemIcon>
        <p>Logout</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      {isAppBarVisible(location) && (
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="fixed">
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="open drawer"
                sx={{ mr: 2 }}
                onClick={props.toggleDrawer}
              >
                <MenuIcon />
              </IconButton>

              <img
                src={Logo}
                alt="Logo"
                style={{ height: 35, paddingRight: 10 }}
              />

              <Box sx={{ flexGrow: 1 }} />

              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <ListItemButton
                  component="a"
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                >
                  <ListItemText
                    data-test={"appbar-user-full-name"}
                    primary={fullName}
                    primaryTypographyProps={{
                      style: {
                        fontWeight: "bold",
                        color: "white",
                      },
                    }}
                    secondaryTypographyProps={{
                      style: {
                        color: "white",
                      },
                    }}
                  />
                </ListItemButton>
              </Box>
              <Box sx={{ display: { xs: "flex", md: "none" } }}>
                <IconButton
                  size="large"
                  aria-label="show more"
                  aria-controls={mobileMenuId}
                  aria-haspopup="true"
                  onClick={handleMobileMenuOpen}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
          {renderMobileMenu}
          {renderMenu}
        </Box>
      )}
    </>
  );
}
